module.exports = __webpack_public_path__ + "img/thumb.3c9f11d1.png";